import { useRef, useState, useMemo, useEffect } from "react";
import { useTranslation } from "gatsby-plugin-react-i18next"

import { SearchGridResultsMapper } from "../SearchGrid"
import ArrowDown from "../../images/icons/arrow.svg"
import Pagination from "../Pagination"
import { PaginationProvider } from "../../utils/ctx/PaginationContext"
import useSearch from "../../utils/hooks/useSearch"
import ModelsFilter from "./ModelsFilter";
import BrandsFilter from "./BrandsFilter";
import TextSearchFilter from "./TextSearchFilter";
import { useStore } from "../../utils/ctx/SellingPageContext";
import ClearFilters from "./ClearFilters";
import SellingHero from ".";

const SEARCH_RESULTS_PER_PAGE = 16

// TODO refactor this component (?)
const SellingHeroFilter = () => {
  const { t } = useTranslation()
  const paginationTopScrollRef = useRef<HTMLDivElement>(null)
  const [isFiltersOpen, setIsFiltersOpen] = useState(true)
  const [store, setStore] = useStore((store) => store);
  const { searchQuery, page, selectedBrands, selectedModels } = useMemo(() => store, [store]);

  const { data, isLoading } = useSearch(searchQuery, true, {
    filters: { brand: selectedBrands, model: selectedModels },
    searchLimitting: false,
    limit: SEARCH_RESULTS_PER_PAGE,
    page,
  })

  useEffect(() => {
    if (paginationTopScrollRef.current && window && navigator) {
      setTimeout(() => {
        if (navigator.userAgent.indexOf("Safari") !== -1) {
          window.scrollTo({ left: 0, top: paginationTopScrollRef.current.offsetTop || 0, behavior: 'smooth' })
        } else {
          window.scrollTo(0, paginationTopScrollRef.current.offsetTop || 0);
        }
      }, 250)
    }
  }, [paginationTopScrollRef])

  return (
    <div className="bg-gray">
      <section className="lg:py-12 px-4 lg:px-8 bg-gray max-w-screen-2xl w-full mx-auto flex items-center flex-col">
        <div className="lg:mt-40 flex flex-col justify-center mx-auto">
          <SellingHero title="sellingHero.selectModels" displayForm={false} bgColor="" fullHeight={false} />
          <p
            className="text-black mt-12 lg:mt-24"
            dangerouslySetInnerHTML={{ __html: t("sellingHero.searchText") }}
          />
          <TextSearchFilter paginationTopScrollRef={paginationTopScrollRef} />
          <p className="text-black mt-4">
            {t("referenceSearch.noResultHint")}
            {t("referenceSearch.linkToFaq")}
          </p>
        </div>
        <hr className="w-full my-8" />
      </section>
      <div
        className="max-w-screen-2xl w-full py-6 lg:py-12 px-4 lg:px-8 mx-auto bg-gray"
        ref={paginationTopScrollRef}
      >
        <details
          className="flex w-full mb-14 py-5 flex-col"
          onToggle={() => setIsFiltersOpen(!isFiltersOpen)}
          open
        >
          <summary className="marker:content-none text-xl text-primary flex items-center justify-between w-full">
            <div className="flex items-center">
              <ArrowDown
                className={`transition-all duration-100 h-2 lg:h-3 mr-4 ${isFiltersOpen ? "-rotate-90" : ""
                  }`}
              />
              <span>{t("general.filter")}</span>
            </div>
            <ClearFilters />
          </summary>
          <div className="my-4">
            <BrandsFilter />
            <ModelsFilter />
          </div>
        </details>
        <SearchGridResultsMapper
          query="query"
          data={data}
          isLoading={isLoading}
          bgColor="bg-gray"
          gridClasses="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5"
        />
        <div className="mx-20 my-8">
          <PaginationProvider
            currentPage={page || 1}
            setPage={(page) =>
              setStore({ page })
            }
            scrollRef={paginationTopScrollRef}
          >
            <Pagination
              maxPages={
                data &&
                Math.ceil(data["hydra:totalItems"] / SEARCH_RESULTS_PER_PAGE)
              }
            />
          </PaginationProvider>
        </div>
      </div>
    </div>
  )
}

export default SellingHeroFilter
